import React, { useEffect } from 'react';
import { GEEKBI_HOT_SALE_URL } from '@/constants/geekbiLinks';

export default function GeekbiHotSaleRedirect() {
  useEffect(() => {
    window.location.replace(GEEKBI_HOT_SALE_URL);
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>
      正在跳转到极鲸云选品数据…
    </div>
  );
}
